// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__1OB8B","docList":"footer_docList__jEgmX","docItem":"footer_docItem__t0vxv","title":"footer_title__PqY0d","footerCopyright":"footer_footerCopyright__gelbl"};